import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Ultraship.types'

@Injectable({ providedIn: 'root' })
export class Ultraship_DEPRECATED_import_inbound_shipment_request_payloadService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { loadContainerId: number, orderId?: number, shipmentId?: number }): Promise<{ outputDetails?: string[], outputMapResult?: $types.Ultraship.Shipment[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.loadContainerId)) {
      missingRequiredInParams.push('\'loadContainerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Ultraship/functions/DEPRECATED_import_inbound_shipment_request_payload`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

